import { makePartners } from 'src/main/factories/pages'

export default makePartners
